import React from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Card,
    CardContent,
    Grid,
    Typography
} from "@mui/material";
import {Done} from "@mui/icons-material";
import {FloatingActions} from "~/apps/core/ui/FloatingActions";
import {Close, DoneFilled, LinaArrowRight} from "~/ui/icons";
import makeStyles from "@mui/styles/makeStyles";
import {PortTheme} from "~/ui/theme";

export type OrderCreateResultProps = {
    onContinue?: () => void
}


const useStyles = makeStyles<PortTheme>(theme => ({
    iconContainer: {
        width: 100,
        height: 100,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#FFFFFF",
        padding: 22,
        fontWeight: 700,
        backgroundColor: theme.palette.additionalPrimary.main,
        backgroundClip: "padding-box",
        borderRadius: 106,
        borderStyle: "solid",
        borderColor: "#009ACF19",
        borderWidth: 15,
        "& .MuiSvgIcon-root": {
            width: 35,
            height: 35,
        }
    },
    iconContainerError: {
        backgroundColor: '#C83C33',
        borderColor: 'rgba(200, 60, 51, 0.1)'
    },
    card: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: 'calc(100vh - 153px)',

    },
    content: {
        textAlign: "center",
        overflow: 'scroll',
    },
    errorDescription: {
        borderRadius: '6px',
        padding: '10px',
        background: 'rgba(110, 121, 140, 0.07)',
        textAlign: 'left'
    },
    accordionItem: {
        '&:not(:last-child)': {
            marginBottom: 8,
        }
    },
    accordion: {
        background: 'rgba(110, 121, 140, 0.07)',

    },
    accordionSummary: {
        minHeight: '44px',

    },
    accordionSummaryContent: {
        alignItems: 'center'
    },
    accordionContent: {
        textAlign: 'left'
    },
    failIndicator: {
        width: 6,
        height: 6,
        borderRadius: 3,
        background: '#E53328',
        marginRight: 6,
    },
    expandIcon: {
        '& path': {
            stroke: '#B6BBC5'
        }
    },
}));

export const OrderCreateResult = (props: OrderCreateResultProps) => {
    const { onContinue } = props;
    const classes = useStyles(props);

    const handleNextClick = () => {
        onContinue && onContinue();
    }

    const isSuccess = false;

    const success = (
        <Grid container direction="column" alignItems="center">
            <Grid item>
                <div className={classes.iconContainer}>
                    <Done color="inherit"/>
                </div>
            </Grid>
            <Grid item marginTop="32px">
                <Typography variant="screenTitle" color="primary">
                    Наряд на авто успешно создан
                </Typography>
            </Grid>
        </Grid>
    )

    const failure = (
        <Grid container direction="column" alignItems="center">
            <Grid item>
                <div className={[classes.iconContainer, classes.iconContainerError].join(' ')}>
                    <Close />
                </div>
            </Grid>
            <Grid item marginTop="32px">
                <Typography variant="screenTitle" color="primary">
                    Не удалось создать наряд на авто
                </Typography>
            </Grid>
            <Grid item marginTop="12px">
                <Box className={classes.errorDescription}>
                    <Typography variant="screenSubtitle" color="secondary">
                        Уважаемый экспедитор, для создания наряда/поручения на груз DLTU9011048, прибывший с ЖД, с изменением направления убытия, просим обратиться по эл. адресу: incenter@fesco.com или номеру телефона: +7 (423) 230-21-12 (33351).
                    </Typography>
                </Box>
            </Grid>
            <Grid item marginTop="12px">
                <Box className={classes.accordionItem}>
                    <Accordion elevation={null} className={classes.accordion} disableGutters>
                        <AccordionSummary
                            classes={{
                                root: classes.accordionSummary,
                                expanded: classes.accordionSummaryExpanded,
                                content: classes.accordionSummaryContent
                            }}
                            expandIcon={<LinaArrowRight className={classes.expandIcon} />}
                        >
                            <Box className={classes.failIndicator} />
                            <Typography variant="cardTitle1" color="primary">
                                DLTU9011049
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails classes={{root: classes.accordionContent}}>
                            <Typography variant="screenSubtitle" color="secondary">
                                Уважаемый экспедитор, для создания наряда/поручения на груз DLTU9011048, прибывший с ЖД, с изменением направления убытия, просим обратиться по эл. адресу: incenter@fesco.com или номеру телефона: +7 (423) 230-21-12 (33351).
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                </Box>
                <Box className={classes.accordionItem}>
                    <Accordion elevation={null} className={classes.accordion} disableGutters>
                        <AccordionSummary
                            classes={{
                                root: classes.accordionSummary,
                                expanded: classes.accordionSummaryExpanded,
                                content: classes.accordionSummaryContent
                            }}
                            expandIcon={<LinaArrowRight className={classes.expandIcon} />}
                        >
                            <Box className={classes.failIndicator} />
                            <Typography variant="cardTitle1" color="primary">
                                DLTU9011049
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails classes={{root: classes.accordionContent}}>
                            <Typography variant="screenSubtitle" color="secondary">
                                Уважаемый экспедитор, для создания наряда/поручения на груз DLTU9011048, прибывший с ЖД, с изменением направления убытия, просим обратиться по эл. адресу: incenter@fesco.com или номеру телефона: +7 (423) 230-21-12 (33351).
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                </Box>
                <Box className={classes.accordionItem}>
                    <Accordion elevation={null} className={classes.accordion} disableGutters>
                        <AccordionSummary
                            classes={{
                                root: classes.accordionSummary,
                                expanded: classes.accordionSummaryExpanded,
                                content: classes.accordionSummaryContent
                            }}
                            expandIcon={<LinaArrowRight className={classes.expandIcon} />}
                        >
                            <Box className={classes.failIndicator} />
                            <Typography variant="cardTitle1" color="primary">
                                DLTU9011049
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails classes={{root: classes.accordionContent}}>
                            <Typography variant="screenSubtitle" color="secondary">
                                Уважаемый экспедитор, для создания наряда/поручения на груз DLTU9011048, прибывший с ЖД, с изменением направления убытия, просим обратиться по эл. адресу: incenter@fesco.com или номеру телефона: +7 (423) 230-21-12 (33351).
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                </Box>
            </Grid>
        </Grid>
    )

    return (
        <>
            <Card className={classes.card}>
                <CardContent className={classes.content}>
                    {isSuccess
                        ? success
                        : failure
                    }
                </CardContent>
            </Card>

            <Box minHeight={80} height={80}/>
            <FloatingActions>
                <Button fullWidth onClick={handleNextClick} startIcon={<DoneFilled/>}>
                    Готово
                </Button>
            </FloatingActions>
        </>
    )
}